import script from "./OTPVerification.vue?vue&type=script&setup=true&lang=js"
export * from "./OTPVerification.vue?vue&type=script&setup=true&lang=js"

import "./OTPVerification.vue?vue&type=style&index=0&id=043859ee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-043859ee"]])

export default __exports__